function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Icon from './lib/icon';
export const IconAlert = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4m0 2C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6m0 13.127a1.399 1.399 0 1 1-.001 2.798A1.399 1.399 0 0 1 16 19.127m0-8.627c.783 0 1.199.516 1.2 1.156l-.423 5.614c-.052.366-.415.546-.776.546s-.72-.212-.777-.546l-.429-5.61c.006-.644.42-1.16 1.206-1.16"
    }));
export const IconError = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M26.45 24.1 16 5.814 5.55 24.1zm-23.231.453 12-21a.89.89 0 0 1 .782-.453c.304 0 .608.151.78.453l12 21A.9.9 0 0 1 28 25.9H4a.9.9 0 0 1-.781-1.347m14.18-3.549a1.398 1.398 0 1 1-2.797 0 1.398 1.398 0 0 1 2.796 0M16 11c.782 0 1.198.516 1.199 1.156 0 .057-.423 5.614-.423 5.614-.052.366-.415.546-.776.546s-.72-.212-.777-.546c0 0-.43-5.558-.429-5.61.006-.644.42-1.16 1.206-1.16"
    }));
export const IconInfo = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M26 4a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 2H6v20h20zm-8.59 15.41a1.41 1.41 0 1 0-2.821.001 1.41 1.41 0 0 0 2.821 0M16 9c3.005 0 5 1.697 5 3.965 0 2.13-1.384 3.238-3.843 3.692l-.157.027V18a1 1 0 0 1-.883.993L16 19a1 1 0 0 1-.993-.883L15 18v-2a1 1 0 0 1 .92-.997c2.205-.175 3.08-.84 3.08-2.038 0-1.085-1.034-2.165-3-2.165-1.494 0-2.5.715-3.148 1.77a1 1 0 1 1-1.704-1.046C12.176 9.85 13.837 9 16 9"
    }));
export const IconSuccess = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M25.147 8.305a1.096 1.096 0 0 1 1.548-.158 1.097 1.097 0 0 1 .158 1.548L15.963 23c-.214.261-.594.39-.979.388-.376-.003-.755-.132-.984-.388l-6.804-7.25a1.097 1.097 0 0 1 .053-1.554 1.097 1.097 0 0 1 1.555.053l6.198 6.735z"
    }));
export const IconCritical = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M26.45 24.1 16 5.814 5.55 24.1zm-23.231.453 12-21a.89.89 0 0 1 .782-.453c.304 0 .608.151.78.453l12 21A.9.9 0 0 1 28 25.9H4a.9.9 0 0 1-.781-1.347m14.18-3.549a1.398 1.398 0 1 1-2.797 0 1.398 1.398 0 0 1 2.796 0M16 11c.782 0 1.198.516 1.199 1.156 0 .057-.423 5.614-.423 5.614-.052.366-.415.546-.776.546s-.72-.212-.777-.546c0 0-.43-5.558-.429-5.61.006-.644.42-1.16 1.206-1.16"
    }));
export const IconInformation = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M20 14.195a.9.9 0 0 1 .113 1.793l-.113.007-3-.001V24.2h3a.9.9 0 0 1 .113 1.793L20 26h-8a.9.9 0 0 1-.113-1.793L12 24.2h3v-8.206h-3a.9.9 0 0 1-.113-1.792l.113-.007zM16 5.2a3.4 3.4 0 1 1 0 6.8 3.4 3.4 0 0 1 0-6.8M16 7a1.6 1.6 0 1 0 0 3.2A1.6 1.6 0 0 0 16 7"
    }));
export const IconNotification = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4m0 2C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6m0 13.127a1.399 1.399 0 1 1-.001 2.798A1.399 1.399 0 0 1 16 19.127m0-8.627c.783 0 1.199.516 1.2 1.156l-.423 5.614c-.052.366-.415.546-.776.546s-.72-.212-.777-.546l-.429-5.61c.006-.644.42-1.16 1.206-1.16"
    }));
export const IconPositive = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M25.147 8.305a1.096 1.096 0 0 1 1.548-.158 1.097 1.097 0 0 1 .158 1.548L15.963 23c-.214.261-.594.39-.979.388-.376-.003-.755-.132-.984-.388l-6.804-7.25a1.097 1.097 0 0 1 .053-1.554 1.097 1.097 0 0 1 1.555.053l6.198 6.735z"
    }));
export const IconWarning = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M3.6 17.208a1.704 1.704 0 0 1 0-2.415L14.792 3.6c.333-.333.77-.5 1.208-.5s.874.167 1.207.5L28.4 14.792c.333.333.5.77.5 1.208s-.167.874-.5 1.207L17.207 28.4a1.704 1.704 0 0 1-2.415 0zM16 27.062 27.062 16 16 4.938 4.938 16zm1.398-6.037a1.398 1.398 0 1 1-2.796 0 1.398 1.398 0 0 1 2.796 0M16.001 11c.782 0 1.198.516 1.199 1.156 0 .057-.423 5.614-.423 5.614-.052.366-.415.546-.776.546s-.72-.212-.777-.546c0 0-.43-5.558-.429-5.61.006-.644.42-1.16 1.206-1.16"
    }));
